import React from 'react';

import { GraduateCapIcon } from '@test_prep/app/ai_tutor/components/icons';

import style from './style.module.scss';

interface Props {
  onClick: () => void;
}

export default (props: Props) => {
  return (
    <div className={style.button} onClick={props.onClick}>
      <div className="hidden-xs">
        <GraduateCapIcon size={30} />
      </div>

      <div className="visible-xs">
        <GraduateCapIcon size={25} />
      </div>
    </div>
  );
};
